import styled from 'styled-components';

export const AccordionContent = styled.div<{ isActive: boolean }>`
  height: ${(props) => (props.isActive ? 'fit-content' : '0')};
  overflow: hidden;
  transition: height 0.2s ease-out;
  border-bottom: ${(props) =>
    props.isActive ? `1px solid var(--color-grey-8)` : 'none'};
`;
